// -- import * as _ from "lodash-es"
import * as _date from "date-fns"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "PurchTable"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "PurchId",
      label: "采购订单编码",
      sortable: true
    },
    {
      key: "OrderAccount",
      label: "供应商帐户",
      sortable: true
    },
    {
      key: "OrderAccountName",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true
    },
    {
      key: "InclTax",
      label: "价格包括销售税",
      sortable: true
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    }

  ],
  item_fields: [
    {
      key: "LineNumber",
      label: "行号",
      sortable: true
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "PurchQty",
      label: "数量",
      sortable: true,
      type: "integer",
      _precise: 6
    },
    {
      key: "PurchUnit",
      label: "单位",
      sortable: true
    },
    {
      key: "PurchPrice",
      label: "价格",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "LineAmount",
      label: "本币不含税",
      sortable: true,
      type: "number",
      _precise: 2
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "RetailVariantId",
      label: "变形编号",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "DeliveryDate",
      label: "交货日期",
      sortable: true,
      type: "date"
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    }
  ],
  delivery_plan_default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "PurchId",
      label: "采购订单编码",
      sortable: true
    },
    {
      key: "OrderAccount",
      label: "供应商帐户",
      sortable: true
    },
    {
      key: "OrderAccountName",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true
    },
    {
      key: "InclTax",
      label: "价格包括销售税",
      sortable: true
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "is_complated",
      label: "完成状态",
      sortable: true,
      thStyle: {
        width: "80px"
      },
      type: "state",
      context: ["未完成", "已完成"]
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    }
  ],
  delivery_plan_fileds: [
    {
      key: "PurchId",
      label: "采购单号",
      sortable: true
    },
    {
      key: "LineNumber",
      label: "行号",
      sortable: true
    },
    {
      key: "OrderAccount",
      label: "供应商编号",
      sortable: true
    },
    {
      key: "PurchQty",
      label: "采购数量",
      sortable: true
    },
    {
      key: "DeliveryQty",
      label: "计划数量",
      editable: true,
      type: "number"
    },
    {
      key: "DeliveryDate",
      label: "交期",
      editable: true,
      type: "date"
    },
    {
      key: "Remark",
      label: "备注",
      editable: true,
      type: "textarea"
    }
  ]
}

const dataForm = {
  id: "",
  PurchId: "",
  OrderAccount: "", //供应商账户
  OrderAccountName: "", //供应商名称
  CurrencyCode: "",
  InclTax: false,
  dataAreaId: "", //公司
  modifiedDateTime: "",
  AX_PurchId: "", //AX采购单编号
  AX_SalesOrderId: "" //AX销售单编号
}

const dataItemForm = {
  id: "",
  PurchaseOrderId: "",
  LineNumber: "",
  ItemId: "",
  NameAlias: "",
  PurchQty: "", //数量
  PurchPrice: "",
  PurchUnit: "",
  LineAmount: "",
  modifiedDateTime: "",
  createdDateTime: "",
  dataAreaId: "", //公司
  DeliveryDate: "", //交货日期
  RetailVariantId: "",
  VariantName: "",
  AX_Line_PurchId: "", //AX采购单行编号
  AX_Line_SalesOrderId: "" //AX销售单行编号
}
const dataDeliveryForm = {
  id: "", //主键
  PurchId: "", //采购单号
  LineNumber: "", //行号
  OrderAccount: "", //供应商编号
  PurchQty: "", //采购单数量
  DeliveryQty: "", //交货数量
  DeliveryDate: "", //交期
  Remark: "" //备注
}

///前端验证
const rules = {}

const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const methods = {
  //查询
  async getDeliveryPlanItems(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_Delivery_Plan",
      create,
      descriptor
    )
    let _fields = _.map(fields.delivery_plan_fileds, "key")
    _fields.push("id")
    let result = await item_biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //保存delivery
  async saveDeliveryPlan(add_list, update_list) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_Delivery_Plan",
      create,
      descriptor
    )
    let _actions = []
    for (var i in add_list) {
      delete add_list[i].id
      _actions.push(
        item_biz_data
          .insertAction({
            params: add_list[i],
            fields: _.map(fields.delivery_plan_fileds, "key")
          })
          .action({})
      )
    }
    for (var i in update_list) {
      _actions.push(
        item_biz_data
          .updateAction({
            params: update_list[i],
            fields: ["id"]
          })
          .action({})
      )
    }

    let result = await api.query_batch({
      actions: _actions
    })
    //
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  async deleteDeliveryPlan(items) {
    let _actions = []

    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_Delivery_Plan",
      create,
      descriptor
    )

    _.each(items, t => {
      _actions.push(
        item_biz_data
          .deleteAction({
            params: {
              id: t.id
            }
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let is_ok = false
      let reActions = result.data.BatchResult.Actions
      let reFilter = _.filter(reActions, {
        Code: "data/d/sPlant_Delivery_Plan"
      })
      _.each(reFilter, t => {
        if (
          t.Result &&
          !_.isNull(t.Result) &&
          t.Result.Data &&
          !_.isNull(t.Result.Data) &&
          t.Result.Data.length > 0
        ) {
          is_ok = true
        }
      })

      return is_ok
    } else {
      return null
    }
  },
  ///getdata
  async getData(_params) {
    let _fields = _.map(fields.default, "key")
    let po_biz_data = new biz_data_helper.base_entity_helper(
      "get_deliveryplan_purchorder",
      {},
      {}
    )
    let result = await po_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },

  async getItemData(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "PurchLine",
      create,
      descriptor
    )
    let _fields = _.map(fields.item_fields, "key")
    _fields.push("id")
    _fields.push("PurchaseOrderId")

    let result = await item_biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },

  ///创建采购单及明细
  async createData(masterList, itemList) {
    let _actions = []

    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_seq",
      {},
      {}
    )

    const item_biz_data = new biz_data_helper.base_entity_helper(
      "PurchLine",
      {},
      {}
    )

    //获取code
    let _p = {
      type: "CPO",
      date: _date.format(new Date(), "yyyy-MM-dd")
    }
    _.each(masterList, t => {
      let _mt = _.cloneDeep(t)
      delete _mt.id
      _actions.push(
        code_biz_data
          .execAction({
            params: _p,
            fields: ["seq"]
          })
          .action({
            output_last_item_map: {
              seq: "PurchId"
            }
          })
      )
      _actions.push(
        biz_data
          .insertAction({
            params: _mt,
            fields: _.map(fields.default, "key")
          })
          .action({
            output_last_item_map: {
              id: "PurchaseOrderId"
            },
            mixin_last_item_map: {
              PurchId: "PurchId"
            }
          })
      )
      let _items = _.filter(itemList, {
        OrderAccount: t.OrderAccount
      })
      _.each(_items, m => {
        let _ml = _.cloneDeep(m)
        delete _ml.id
        delete _ml.OrderAccount
        _actions.push(
          item_biz_data
            .insertAction({
              params: _ml,
              fields: _.map(fields.item_fields, "key")
            })
            .action({
              mixin_last_item_map: {
                PurchaseOrderId: "PurchaseOrderId"
              }
            })
        )
      })
    })


    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[2].Result.Data.length > 0
    ) {
      return result.data.BatchResult.Actions[2].Result.Data
    } else {
      return null
    }
  },
  async updateItemData(items) {
    let _actions = []
    const item_biz_data = new biz_data_helper.base_entity_helper(
      "PurchLine",
      {},
      {}
    )
    _.each(items, m => {
      let _ml = _.cloneDeep(m)
      _actions.push(
        item_biz_data
          .selectAction({
            params: {
              OrderDispatch_id: _ml.OrderDispatch_id
            },
            fields: ["id"]
          })
          .action({
            output_last_item_map: {
              id: "id"
            }
          })
      )
      _actions.push(
        item_biz_data
          .updateAction({
            params: _ml,
            fields: _.map(fields.item_fields, "key")
          })
          .action({
            mixin_last_item_map: {
              id: "id"
            }
          })
      )
    })


    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  async delItemData(items) {
    let _actions = []
    const item_biz_data = new biz_data_helper.base_entity_helper(
      "PurchLine",
      {},
      {}
    )
    _.each(items, m => {
      let _ml = _.cloneDeep(m)
      _actions.push(
        item_biz_data
          .selectAction({
            params: {
              OrderDispatch_id: _ml.OrderDispatch_id
            },
            fields: ["id"]
          })
          .action({
            output_last_item_map: {
              id: "id"
            }
          })
      )
      _actions.push(
        item_biz_data
          .deleteAction({
            params: _ml,
            fields: _.map(fields.item_fields, "key")
          })
          .action({
            mixin_last_item_map: {
              id: "id"
            }
          })
      )
    })


    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  }
}
export {
  biz_data, dataDeliveryForm, dataForm,
  dataItemForm, fields, methods,
  rules
};

